import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import api from '../services/api'

const BooksTalkDetail = () => {
  const { id } = useParams()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
  }, [id])

  const fetchData = async () => {
    try {
      const res = await api.get(`/books-talk/${id}`)
      if (res.code === 0) {
        setData(res.data)
        // 调试：检查音频数据
        console.log('=== BooksTalk Detail Debug ===')
        console.log('Content length:', res.data.content ? res.data.content.length : 0)
        if (res.data.content) {
          const audioMatch = res.data.content.match(/<audio[^>]*src="([^"]*)"[^>]*><\/audio>/g)
          console.log('Audio tags found:', audioMatch ? audioMatch.length : 0)
          if (audioMatch && audioMatch.length > 0) {
            audioMatch.forEach((tag, idx) => {
              const srcMatch = tag.match(/src="([^"]*)"/)
              if (srcMatch) {
                console.log(`Audio ${idx + 1} src length:`, srcMatch[1].length)
                console.log(`Audio ${idx + 1} src preview:`, srcMatch[1].substring(0, 50))
              }
            })
          }
        }
      }
    } catch (error) {
      console.error('加载失败:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="book-detail-loading">加载中...</div>
    )
  }

  if (!data) {
    return (
      <div className="book-detail-error">内容不存在</div>
    )
  }

  // 处理内容格式：将纯文本转换为段落，保留图片和音频标签
  const formatContent = (content) => {
    if (!content) return ''
    
    // 如果已经是纯<p>标签格式，直接返回
    if (content.startsWith('<p>') || content.startsWith('<p ')) {
      return content
    }
    
    // 分离HTML标签和纯文本
    const parts = content.split(/(<img[^>]*\/>|<audio[^>]*><\/audio>)/gi)
    
    let result = ''
    let currentText = ''
    
    parts.forEach((part, index) => {
      const isHtmlTag = part.match(/^<img|^<audio/i)
      
      if (isHtmlTag) {
        // 处理前面累积的文本
        if (currentText.trim()) {
          // 按换行符分段，完全清除所有空格（由CSS text-indent负责缩进）
          const paragraphs = currentText.split('\n')
            .map(p => p.trim())  // 清除每行的前后空格
            .filter(p => p.length > 0)
          
          if (paragraphs.length > 0) {
            result += paragraphs.map(p => `<p>${p}</p>`).join('')
          } else {
            result += `<p>${currentText.trim()}</p>`
          }
        }
        // 添加HTML标签
        result += part
        currentText = ''
      } else {
        // 累积纯文本
        currentText += part
      }
    })
    
    // 处理最后剩余的文本
    if (currentText.trim()) {
      const paragraphs = currentText.split('\n')
        .map(p => p.trim())  // 清除每行的前后空格
        .filter(p => p.length > 0)
      
      if (paragraphs.length > 0) {
        result += paragraphs.map(p => `<p>${p}</p>`).join('')
      } else {
        result += `<p>${currentText.trim()}</p>`
      }
    }
    
    return result
  }

  return (
    <div className="book-detail">
      <div className="book-detail-header">
        <div className="book-detail-cover">
          {data.cover_image ? (
            <img src={data.cover_image} alt={data.title} />
          ) : (
            <div className="book-detail-cover-placeholder">📚</div>
          )}
        </div>
        <div className="book-detail-info">
          <h1 className="book-detail-title">{data.title}</h1>
          {data.category && (
            <div className="book-detail-category">{data.category.name}</div>
          )}
        </div>
      </div>
      <div 
        className="book-detail-content"
        dangerouslySetInnerHTML={{ __html: formatContent(data.content) || '' }}
      />
    </div>
  )
}

export default BooksTalkDetail
